import { cn } from '~/lib/utils';

export const ImageBackground = ({
  imageUrl,
  className,
  backgroundSize = 'cover',
  backgroundPosition = '50%',
  loading = 'lazy',
  priority = false,
}: {
  imageUrl: string;
  className?: string;
  backgroundSize?: string;
  backgroundPosition?: string;
  loading?: 'lazy' | 'eager';
  priority?: boolean;
}) => {
  const isObjectFit = ['cover', 'contain', 'fill', 'none', 'scale-down'].includes(backgroundSize);

  return (
    <img
      src={imageUrl}
      alt=""
      loading={priority ? 'eager' : loading}
      decoding="async"
      fetchPriority={priority ? 'high' : 'low'}
      style={{
        objectPosition: backgroundPosition,
        ...(isObjectFit ? { objectFit: backgroundSize as any } : { width: backgroundSize, height: '100%' })
      }}
      className={cn('absolute inset-0 w-full h-full', className)}
    />
  );
};
